import { Layer } from './layer';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import GeoJSON from 'ol/format/GeoJSON';

import { Circle as CircleStyle, Icon, Circle, Fill, Stroke, Style, Text } from 'ol/style';


export class GeoJsonLayer extends Layer {


  declare label: string;
  declare url: string;
  declare type: string;
  themes: string[] = new Array();


  constructor(id: string, label: string, url: string, type: string, themes?: [string]) {    
    super(id, label, url);
    this.url = url;
    if (themes) {
      this.themes = themes;
    }
  }

  toOlLayer() {
    let vectorLayer =
      new VectorLayer({
        source: new VectorSource({
          format: new GeoJSON(),
          url: this.url,
        }),
        visible: true,
        // title: this.label,
        // customId: this.id,
        //temp!
        // style: new Style({
        //   stroke: new Stroke({
        //     color: 'rgba(205,205,205,1.0)',
        //     width: 3,
        //   }),
        //   fill: new Fill({
        //     color: 'rgba(234,89,1,0.5)'
        //   })
        // })
      })
    vectorLayer.set('title', this.label);
    vectorLayer.set('customId', this.id);

    return vectorLayer;
  }
}